import { ApiError } from '@gorila-shared-ui/components';
import { ApiEndpoint } from '../types/api';
import { Asset, AssetCore } from '../types/asset';
import { DtcRecord } from '../types/currentState';
import { getStartDate, getStartDateFromDate } from '../utils/dates';
import { getRequest, postRequest } from './api';
import { assetDtcUrl, assetUrl, getAssetsUrl, getSearchAssetsUrl } from './urls/assetUrls';

export const getAssets = async (
  clientId: string,
  subClientId?: string,
  search?: string,
  assets?: string[],
  exclude?: string[]
): Promise<{ assets?: Asset[]; error?: ApiError }> => {
  const response = await getRequest(getAssetsUrl, {
    queryParams: {
      clientId,
      subClientId,
      search,
      assets,
      exclude,
      all_items: true,
    },
  });
  return {
    assets: response?.data?.items,
    error: response?.error,
  };
};

export const getSearchAssets = async (
  clientId?: string,
  subClientId?: string,
  page?: number,
  search?: string,
  include?: string[],
  exclude?: string[]
): Promise<{ assets?: Asset[]; error?: ApiError; total: number; hasNext: boolean }> => {
  const body = {
    clientId,
    subClientId,
    page: page ?? 1,
    search,
    include,
    exclude,
  };
  const response = await postRequest(
    getSearchAssetsUrl,
    {
      body,
    },
    ApiEndpoint.core
  );
  return {
    assets: response?.data?.items,
    total: response?.data?.total,
    hasNext: response?.data?.hasNext ?? false,
    error: response?.error,
  };
};

export const updateAsset = async (
  clientId: string,
  subClientId: string,
  asset: AssetCore
): Promise<{ id?: string; error?: ApiError }> => {
  const response = await postRequest(assetUrl(asset._id), {
    body: { subClientId, clientId, label: asset.label },
  });

  return {
    id: response?.data?.id,
    error: response?.error,
  };
};

export const getAssetDtc = async (
  assetId: string,
  date?: number
): Promise<{ records?: DtcRecord[]; error?: ApiError }> => {
  const queryParams = {
    date: date ? getStartDateFromDate(new Date(date)) : getStartDate(),
  };
  const response = await getRequest(assetDtcUrl(assetId), {
    queryParams,
  });
  return {
    records: response?.data,
    error: response?.error,
  };
};
